import { __extends } from "tslib";
import { RedactChannelMessageRequest, RedactChannelMessageResponse } from "../models/models_0";
import { deserializeAws_restJson1RedactChannelMessageCommand, serializeAws_restJson1RedactChannelMessageCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Redacts message content, but not metadata. The message exists in the back end, but the
 *          action returns null content, and the state shows as redacted.</p>
 *
 *          <note>
 *             <p>The <code>x-amz-chime-bearer</code> request header is mandatory. Use the
 *                <code>AppInstanceUserArn</code> of the user that makes the API call as the value in
 *             the header.</p>
 *          </note>
 * @example
 * Use a bare-bones client and the command you need to make an API call.
 * ```javascript
 * import { ChimeSDKMessagingClient, RedactChannelMessageCommand } from "@aws-sdk/client-chime-sdk-messaging"; // ES Modules import
 * // const { ChimeSDKMessagingClient, RedactChannelMessageCommand } = require("@aws-sdk/client-chime-sdk-messaging"); // CommonJS import
 * const client = new ChimeSDKMessagingClient(config);
 * const command = new RedactChannelMessageCommand(input);
 * const response = await client.send(command);
 * ```
 *
 * @see {@link RedactChannelMessageCommandInput} for command's `input` shape.
 * @see {@link RedactChannelMessageCommandOutput} for command's `response` shape.
 * @see {@link ChimeSDKMessagingClientResolvedConfig | config} for command's `input` shape.
 *
 */
var RedactChannelMessageCommand = /** @class */ (function (_super) {
    __extends(RedactChannelMessageCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function RedactChannelMessageCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    RedactChannelMessageCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "ChimeSDKMessagingClient";
        var commandName = "RedactChannelMessageCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: RedactChannelMessageRequest.filterSensitiveLog,
            outputFilterSensitiveLog: RedactChannelMessageResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    RedactChannelMessageCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1RedactChannelMessageCommand(input, context);
    };
    RedactChannelMessageCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1RedactChannelMessageCommand(output, context);
    };
    return RedactChannelMessageCommand;
}($Command));
export { RedactChannelMessageCommand };
//# sourceMappingURL=RedactChannelMessageCommand.js.map